import { render, staticRenderFns } from "./LookupsView.vue?vue&type=template&id=d035f644"
import script from "./LookupsView.vue?vue&type=script&lang=js"
export * from "./LookupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports